/* eslint-disable @typescript-eslint/no-explicit-any */
import { Label } from "@/components/ui/label";

const FIELD_TRANSLATIONS: { [key: string]: string } = {
  is_active: "Status Ativo",
  state: "Estado",
  iva: "IVA (%)",
  internal_tax_rate: "Alíquota Interna (%)",
  interstate_tax: "Imposto Interestadual (%)",
};

export function NCMChanges({ changes }: { changes: any }) {
  if (!changes || Object.keys(changes).length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      <Label className="text-lg">Alterações Realizadas</Label>
      <div className="border rounded-md p-4 bg-gray-50 space-y-3">
        {Object.entries(changes).map(([field, value]: any, index) => (
          <div key={index} className="border-b pb-2 last:border-none">
            <p className="font-medium text-gray-700">
              {FIELD_TRANSLATIONS[field] || field}
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="p-2 bg-red-100 text-red-600 rounded-md">
                <span className="text-sm">Antes:</span>{" "}
                {typeof value.old === "boolean"
                  ? value.old
                    ? "Ativo"
                    : "Inativo"
                  : value.old}
              </div>
              <div className="p-2 bg-green-100 text-green-600 rounded-md">
                <span className="text-sm">Depois:</span>{" "}
                {typeof value.new === "boolean"
                  ? value.new
                    ? "Ativo"
                    : "Inativo"
                  : value.new}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
